module.exports = {"371324001":"卞庄街道","371324002":"苍山街道","371324101":"大仲村镇","371324102":"兰陵镇","371324103":"长城镇","371324104":"磨山镇","371324105":"神山镇","371324106":"车辋镇","371324107":"尚岩镇","371324108":"向城镇","371324109":"新兴镇","371324110":"南桥镇","371324112":"庄坞镇","371324114":"鲁城镇","371324115":"矿坑镇","371324117":"芦柞镇","371324202":"下村乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/371324.json
// module id = 1581
// module chunks = 0